<template>
  <div class="history">
    <v-data-table
      :headers="headers.length ? headers : tableHeaders"
      :items="items"
      :disableSort="true"
      :hideDefaultFooter="true"
    />
  </div>
</template>
<script>
export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        headers: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        tableHeaders() {
            return [
                'date',
                'details',
                'action',
            ].map(header => ({
                text: this.$t(`forms.labels.${header}`),
                value: header,
            }));
        },
    },
};
</script>
<style lang="scss" scoped>
.history {
    border: 1px solid #BDC2D0;
    margin: 0 6rem;
}

@media screen and (max-width: 600px) {
    .history{
        width: 100%!important;
        margin: 0!important;
    }
}
</style>
